"use client";

import Link from "@/components/AppLink";
import { Box } from "@mui/material";

/** Pills in a soft track (tabs of a page). */
export default function Segmented<T extends string>({ items, value, onChange, label }: { items: { value: T; label: string; href?: string }[]; value: T; onChange?: (v: T) => void; label: string }) {
  return (
    <Box role="tablist" aria-label={label} sx={{ display: "inline-flex", gap: 0.5, p: 0.5, borderRadius: 999, bgcolor: "action.hover", maxWidth: "100%", overflowX: "auto", scrollbarWidth: "none" }}>
      {items.map((it) => {
        const on = it.value === value;
        const sx = { font: "inherit", px: 2, minHeight: 36, display: "inline-flex", alignItems: "center", borderRadius: 999, fontSize: 13, fontWeight: 600, whiteSpace: "nowrap", textDecoration: "none", border: 0, cursor: "pointer", color: on ? "text.primary" : "text.secondary", bgcolor: on ? "background.paper" : "transparent", boxShadow: on ? 1 : 0, "&:focus-visible": { outline: 2, outlineColor: "secondary.main", outlineOffset: 1 } } as const;
        return it.href ? (
          <Box key={it.value} component={Link} href={it.href} role="tab" aria-selected={on} sx={sx}>{it.label}</Box>
        ) : (
          <Box key={it.value} component="button" type="button" role="tab" aria-selected={on} onClick={() => onChange?.(it.value)} sx={sx}>{it.label}</Box>
        );
      })}
    </Box>
  );
}
